import BAGITEMS_GET_SUCCESS from '../actionTypes/BagItemsActionTypes';

function BagItemsReducer(state = [], action) {
    switch (action.type) {
        case BAGITEMS_GET_SUCCESS:
            return action.bagItems;
        default:
            return state;
    }
}

BagItemsReducer.reducerName = 'bagItems';
export default BagItemsReducer;
